import { useEffect, useState } from "react";
const ProtectedRouteHook = () => {
  // const user =
  //   localStorage.getItem("userajindamuhami") !== null
  //     ? localStorage.getItem("userajindamuhami")
  //     : null;
  // const Data = JSON.parse(localStorage.getItem("userajindamuhami"));
  const userData=JSON.parse(localStorage.getItem("userajindamuhami"))
  
  const [isUser, setIsUser] = useState();
  const [isAdmin, setIsAdmin] = useState();
  const [isSubuser, setIsSubuser] = useState();
  const [isEditor, setIsEditor] = useState();
  const logout = () => {
    localStorage.removeItem("tokenajindamuhami");
    localStorage.removeItem("userajindamuhami");

    window.location.href = "/login";
  };
  useEffect(() => {
    if (userData !== null) {
      if (userData.RoleName === "User") {
        setIsUser(true);
        setIsAdmin(false);
        setIsSubuser(false);
        setIsEditor(false);
      } else if (userData.RoleName === "Admin") {
        //Admin
        setIsUser(false);
        setIsAdmin(true);
        setIsSubuser(false);
        setIsEditor(false);
      } else if (userData.RoleName === "Editor") {
        setIsUser(false);
        setIsAdmin(false);
        setIsSubuser(false);
        setIsEditor(true);
      } else if (userData.RoleName === "SubUser") {
        setIsUser(false);
        setIsAdmin(false);
        setIsSubuser(true);
        setIsEditor(false);
      } else {
        setIsAdmin(false);
        setIsUser(false);
        setIsSubuser(false);
        setIsEditor(false);
        logout();
      }
    } else {
      setIsAdmin(false);
      setIsUser(false);
      setIsSubuser(false);
      setIsEditor(false);
    }
  }, [userData]);
  return [isUser, isAdmin, userData, isSubuser, isEditor];
};

export default ProtectedRouteHook;
